import { Component, OnInit,NgZone } from '@angular/core';
import { ProvidehttpService } from '../providehttp.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    public http : ProvidehttpService,
    private router: Router,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
  }

  gotoDashboard(){
   
    this.ngZone.run(() => {
      this.router.navigate(['/home/overview']);
      });
  }

}
